import React from 'react';

import { useTranslations } from 'next-intl';

import { DEFAULT_COUNTRY_CALLING_CODE } from 'data/common';
import usePaymentFormContext from 'hooks/usePaymentFormContext';
import Label from 'ui/Label';
import { getPhoneNationalNumber } from 'utils/phone-number-helper';

const VippsPaymentForm = () => {
  const tCheckout = useTranslations('checkout');
  const { vippsPaymentData, vippsPaymentDataErrors, onChangeVippsPhoneNumber } =
    usePaymentFormContext();

  const phoneNationalNumber = getPhoneNationalNumber(vippsPaymentData?.phone ?? '') ?? '';

  const hanldeChangePhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    // Default country calling code is +47 -> Norway calling code
    onChangeVippsPhoneNumber(`${DEFAULT_COUNTRY_CALLING_CODE}${value}`);
  };

  return (
    <div className="space-y-2">
      <div className="border-gray-900/10">
        <div className="mt-2 grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-6">
          <div className="col-span-1 sm:col-span-6">
            <Label htmlFor="phone">{tCheckout('phone')}</Label>
            <div className="relative mt-2 rounded-md shadow-sm">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <span className="text-outerSpace sm:text-sm">+47 &nbsp;|</span>
              </div>
              <input
                autoFocus
                type="tel"
                name="phoneNationalNumber"
                id="phoneNationalNumber"
                className="block w-full rounded border-0 py-3 pl-16 md:pl-14 text-outerSpace ring-1 ring-inset ring-dividerGrey placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6"
                placeholder="123 45 678"
                value={phoneNationalNumber || ''}
                onChange={hanldeChangePhone}
                aria-describedby="price-currency"
              />
            </div>
            {vippsPaymentDataErrors.phone ? (
              <p className="text-red mt-2">{vippsPaymentDataErrors.phone}</p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VippsPaymentForm;
